import {NgModule} from '@angular/core';
import {PageCommonModule} from '../shared/page-common.module';
import {FormsModule} from '../../components/forms/forms.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {VerifyEmailChangePageComponent} from './verify/verify-email-change-page.component';

/**
 * Created by Rodrigo Quesada on 14/08/17.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        NgbModule
    ],
    declarations: [
        VerifyEmailChangePageComponent
    ]
})
export class AccountPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/account/account-page.module.ts